import { Outlet } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

import { Card } from '@/_components';
import { cs } from '@/_shared';

import { useLoginLayout } from './use-login-layout';

export function LoginLayout() {
  useLoginLayout();

  return (
    <main className="flex min-h-screen items-center justify-center p-4 pt-16 md:p-24">
      <Card className={twMerge('relative w-104 max-w-full overflow-visible', 'rounded-3xl', cs('rounded-[2.7rem]'))}>
        <div className="inset-x-0 z-10 -mt-18.5 flex items-center justify-center">
          <div className="login-linear dark:login-linear flex size-36 items-center justify-center rounded-full">
            <img src="/images/stagworks.svg" alt="StagWorks" />
          </div>
        </div>
        <Outlet />
      </Card>
    </main>
  );
}
